export default __webpack_public_path__ + "static/media/0018.b1002bc8.WAV";